import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import ChatBox from '@/components/ChatBox';
import PreSaleH5 from '@/componentsH5/PowerKitPreSale';
import PreSalePC from '@/components/PowerKitPreSale';
import { useLang } from '@/i18n';
import { ActivityIdMap, KeyType } from '@/config/powerkit';
import { redirectTo404 } from '@/utils';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/ecoflow-power-kits';
import { useGlobal } from '@/utils/useGlobal';

//开始时间和截止时间
const dateObjS = {
    us: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_START,
    jp: process.env.NEXT_PUBLIC_MM100_JP_DEADLINE_START,
    kr: process.env.NEXT_PUBLIC_MM100_KR_DEADLINE_START,
    au: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_START,
    cn: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_START,
};
const dateObjE = {
    us: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_END,
    jp: process.env.NEXT_PUBLIC_MM100_JP_DEADLINE_END,
    kr: process.env.NEXT_PUBLIC_MM100_KR_DEADLINE_END,
    au: process.env.NEXT_PUBLIC_MM100_AU_DEADLINE_END,
    cn: process.env.NEXT_PUBLIC_MM100_AU_DEADLINE_END,
};

type Region = keyof typeof dateObjS;

function getDateObjS(locale: Region) {
    return dateObjS[locale] || dateObjS['us'];
}
function getDateObjE(locale: Region) {
    return dateObjE[locale] || dateObjE['us'];
}
//开始时间和截止时间--end

const getCanEnterFlag = (ecoflowid: string) => {
    const date = new Date();
    const day = date.getDay();
    const id = ecoflowid || '';
    const t1 = id.slice(0, 1);
    const t2 = id.slice(1, 5);
    const t3 = id.slice(5);

    //规则1--第1个字母为星期几的首字母
    const dayarr = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    let flag1 = false;
    if (dayarr[day] === t1) {
        flag1 = true;
    }

    //规则2--第2-5的字符串为指定的字符串
    let flag2 = false;
    if (t2 === 'ecof') {
        flag2 = true;
    }

    //规则2--当前小时数+5月12日(512)这个数,有4个数的容量
    let flag3 = false;
    const randomH = 0;
    const hours = date.getHours() + randomH;
    const keyhour = Number(t3 || '');
    const splitHour1 = 2;
    if (hours <= keyhour && keyhour <= hours + splitHour1) {
        flag3 = true;
    }
    console.log(flag1, flag2, flag3);
    return flag1 && flag2 && flag3;
};

export default function TeaserMm100({ isMobile, SEO }: any) {
    const router = useRouter();
    const locale = router.locale as string;

    const hasReadyUpload = ['us', 'ca', 'au', 'uk', 'eu', 'de', 'fr', 'jp', 'kr', 'cn'];
    let defaultReady = hasReadyUpload.includes(locale);
    if (process.env.NODE_ENV === 'development') {
        defaultReady = true;
    }
    const [isReady, setIsReady] = useState<boolean>(defaultReady);
    const ecoflowTime = 1651830849479;
    const startTimeStrA1 = String(getDateObjS(locale as Region)).replace(/-/g, '/');
    const startTimeA1 = new Date(startTimeStrA1).getTime();
    const [renderNum, setRenderNum] = useState<string>('1');
    const timeout = 1000;
    const { t } = useLang('ecoflowpowerkitsseries');
    const LayoutA = isMobile ? PreSaleH5 : PreSalePC; //dynamic(() => import('@/components/PowerKitPreSale'))
    const ecoflowflag = getCanEnterFlag(router?.query?.cid as string);
    let startTime = ecoflowflag ? ecoflowTime : startTimeA1;
    const { getSystemTime } = useGlobal();

    // 多语言 activityId
    const activityId = ActivityIdMap[locale as KeyType] || ActivityIdMap.us;

    //执行倒计
    const timeoutFn = useCallback((serverTime: number) => {
        if (startTime < serverTime) {
            setIsReady(true);
            return null;
        }
        const timeId = setInterval(() => {
            if (startTime < serverTime) {
                setIsReady(true);
                clearInterval(timeId);
            }
            startTime -= timeout;
        }, 1000);
    }, []);

    // 获取服务器时间
    const fetchServerTime = useCallback(() => {
        try {
            const serverTime = getSystemTime();
            //提前1分钟
            const timeErr = 1000 * 60 * 1;
            timeoutFn(serverTime + timeErr);
        } catch (err) {}
    }, [timeoutFn]);

    useEffect(() => {
        setRenderNum('2');
        if (!defaultReady) {
            fetchServerTime();
        }
    }, [defaultReady, fetchServerTime]);

    return (
        <>
            <PageLayout isNoFixed={true} theme="white">
                <SEO title={t('preview.seo_title')} description={t('preview.seo_desc')} />
                <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
                <div className={`${css.seriesview} isReady`}>
                    <LayoutA activityId={activityId} />
                </div>
                <ChatBox locale={router.locale} />
            </PageLayout>
        </>
    );
}

// getStaticProps在next11，带有url参数时useEffect中的接口会重复请求， 改用getServerSideProps
export async function getServerSideProps({ locale }: any) {
    if (['cis'].includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
